import { IconButton, IconButtonProps, IconButtonSize, IconButtonVariant } from '../IconButton';
import { joinClassNames } from '../../utils';
import styles from './Fullscreen.module.scss';
import { IconSize } from '../../enums';
import { MinimiseIcon } from '../Graphics';
import React from 'react';
import { useFullscreen } from './useFullscreen';

type ExitFullscreenButtonProps = Omit<IconButtonProps, 'icon' | 'onClick' | 'size' | 'title'> & {
  title?: string;
  variant?: IconButtonVariant;
  size?: IconButtonSize;
};
export const ExitFullscreenIconButton = ({
  className,
  size = IconButtonSize.Small,
  ...props
}: ExitFullscreenButtonProps) => {
  const fullscreen = useFullscreen();
  const classNames = joinClassNames(styles.exitFullscreenIconButton, className);

  const iconSize: IconSize = size === IconButtonSize.Small ? IconSize.Mini : IconSize.Standard;
  return (
    <IconButton
      icon={<MinimiseIcon size={iconSize} />}
      onClick={() => fullscreen.exit()}
      variant={IconButtonVariant.SolidLight}
      title="Exit full screen"
      className={classNames}
      size={size}
      {...props}
    />
  );
};
